import mainImage from './travel_potty.jpg';
import image1 from './travel_potty1.jpg';
import image2 from './travel_potty2.jpg';
import image3 from './travel_potty3.jpg';

const details = [
    { 
      id: 5,
      name: 'Potette 2-in-1 Travel Potty',
      slideTitle: 'Potette 2-in-1 Travel Potty',
      slideImage: mainImage,
      images: [mainImage, image1, image2, image3],
      description: 'I was first introduced to this travel potty by a friend as she brought it onto the beach for her then toddler. My daughter used it first around the age of 2 and I immediately purchased it when I got home. Five years later, it is still one of my most utilized travel kid item and is always in my car for whenever the kids may need it!',
      link: 'https://amzn.to/48tWXrz',
    }
]

export default details[0];